/**
 * An empty selection and a selection of every visible account mean the same
 * thing: the backend treats a missing `accountIds` as all non-hidden accounts.
 */
export const isAllVisibleAccountsSelected = (selectedAccountsObj, accounts) => {
    const selectedIds = Object.keys(selectedAccountsObj).map(Number);
    if (!selectedIds.length)
        return true;
    const visibleIds = accounts.filter((a) => !a.isHidden).map((a) => a.id);
    if (visibleIds.length !== selectedIds.length)
        return false;
    const selectedSet = new Set(selectedIds);
    return visibleIds.every((id) => selectedSet.has(id));
};
export const normalizeSelectedAccounts = (selectedAccountsObj, accounts) => isAllVisibleAccountsSelected(selectedAccountsObj, accounts)
    ? {}
    : selectedAccountsObj;
